module.exports = __webpack_public_path__ + "img/image-icon.093f2c55.svg";